import {Model} from "@/app/Model";

export class PenaleDashboardFlow {
    public capo_imputazione_legge: string = "";
    public importo_evaso_active: boolean = false;
    public importo_evaso_min: number = Model.lista_importi_minMax[0];
    public importo_evaso_max: number = Model.lista_importi_minMax[1];
    public importo_evaso_da: number = Model.lista_importi_minMax[0];
    public importo_evaso_a: number = Model.lista_importi_minMax[1];
    public assoluzione: string = "";
    public assoluzione_motivo: string = "";
    public pena_principale: string = "";
    public id_localita: string = "";
    public giudice: string = "";
    public data_pronuncia_sentenza_active: boolean = false;
    public data_pronuncia_sentenza_min: number = Model.lista_anno_minMax[0];
    public data_pronuncia_sentenza_max: number = Model.lista_anno_minMax[1];
    public data_pronuncia_sentenza_da: number = Model.lista_anno_minMax[0];
    public data_pronuncia_sentenza_a: number = Model.lista_anno_minMax[1];
    public durata_del_processo_active: boolean = false;
    public durata_del_processo: number = 0;
    public durata_pena_active: boolean = false;
    public durata_pena: number =0;
    public importo_risarcimento_active: boolean = false;
    public importo_risarcimento_min: number = Model.lista_importi_minMax[0];
    public importo_risarcimento_max: number = Model.lista_importi_minMax[1];
    public importo_risarcimento_da: number = Model.lista_importi_minMax[0];
    public importo_risarcimento_a: number = Model.lista_importi_minMax[1];
    public non_menzione_nel_casellario: boolean = false;

    public durata_del_processo_notNull: boolean = false;
    public durata_pena_notNull: boolean = false;

    public paginazione_tot: number = 0;
    public paginazione_start: number = 0; //numero di pagina
    public paginazione_rows: number = Model.pagination_size;
    public paginazione_pages: number = 0;

    public diritto_paginazione_tot: number = 0;
    public diritto_paginazione_start: number = 0; //numero di pagina
    public diritto_paginazione_rows: number = Model.pagination_size;
    public diritto_paginazione_pages: number = 0;

    public reset(): void {
        this.capo_imputazione_legge = "";
        this.importo_evaso_active = false;
        //this.importo_evaso_min = Model.lista_importi_minMax[0];
        //this.importo_evaso_max = Model.lista_importi_minMax[1];
        this.importo_evaso_da =  this.importo_evaso_min; //Model.lista_importi_minMax[0];
        this.importo_evaso_a = this.importo_evaso_max; //Model.lista_importi_minMax[1];
        this.assoluzione = "";
        this.assoluzione_motivo = "";
        this.pena_principale = "";

        this.id_localita = "";
        this.giudice = "";
        this.data_pronuncia_sentenza_active = false;
        //this.data_pronuncia_sentenza_min = Model.lista_anno_minMax[0];
        // this.data_pronuncia_sentenza_max = Model.lista_anno_minMax[1];
        this.data_pronuncia_sentenza_da = this.data_pronuncia_sentenza_min; //Model.lista_anno_minMax[0];
        this.data_pronuncia_sentenza_a = this.data_pronuncia_sentenza_max; //Model.lista_anno_minMax[1];
        this.durata_del_processo_active = false;
        this.durata_del_processo = 0;
        this.durata_pena_active = false;
        this.durata_pena = 0;
        this.importo_risarcimento_active = false;
        //this.importo_risarcimento_min = Model.lista_importi_minMax[0];
        //this.importo_risarcimento_max = Model.lista_importi_minMax[1];
        this.importo_risarcimento_da = this.importo_risarcimento_min; //Model.lista_importi_minMax[0];
        this.importo_risarcimento_a = this.importo_risarcimento_max; //Model.lista_importi_minMax[1];
        this.non_menzione_nel_casellario = false;

        this.durata_del_processo_notNull = false;
        this.durata_pena_notNull = false;

        this.paginazione_tot = 0;
        this.paginazione_start = 0;
        this.paginazione_rows = Model.pagination_size;
        this.paginazione_pages = 0;

        this.diritto_paginazione_tot = 0;
        this.diritto_paginazione_start = 0;
        this.diritto_paginazione_rows = Model.pagination_size;
        this.diritto_paginazione_pages = 0;
    }
}